<template>
    <div class="t2-banner t6_sub_banner wsbs_banner">
        <div class="container">
            <div class="t2_banner_name">
                <h1>企业信用承诺公示</h1>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
</style>
